import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory, Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import moment from 'moment';
import Modal from '@/components/Modal';
import { Flex, Box } from 'UIKit/Grid';
import { StyledButton } from 'UIKit/Form';
import { ROLE, fetchTeacherPaid } from '@/modules/User';
import { TYPE } from '@/modules/Olimpic';

const PurchaseModal = ({
  user,
  olimpic,
  children,
  noDemo,
  olimpicType,
  onLoad,
  exclude,
}) => {
  const history = useHistory();
  const [accessModalShow, setAccessModalShow] = useState(false);

  const { role, ovz, purchases, created_at: created, paid } = user;

  const handleClose = () => {
    setAccessModalShow(false);
    history.push('/profile');
  };

  useEffect(() => {
    if (noDemo) onLoad();
  }, []);

  useEffect(() => {
    // здесь условия скрытия контента и показа модалки об оплате
    if (role === ROLE.ADMIN || (ovz && !olimpicType) || exclude) {
      return;
    } // отображаем конент, если роль админ или юзер овз

    if (olimpicType) {
      // отображем, если нужно показать олимпиаду и она оплачена, каждая индивидуально
      // если онлайн-бесплатная, пускаем без покупки
      if (
        olimpicType === TYPE.ONLINE &&
        (purchases.olimpic_1 || olimpic.online.free === 1)
      ) {
        return;
      }
      if (olimpicType === TYPE.OFFLINE && purchases.olimpic_2) {
        return;
      }
      if (olimpicType === TYPE.PAMA_OFFLINE && purchases.olimpic_4) {
        return;
      }

      setAccessModalShow(true);
      return;
    }

    const isLearner = role === ROLE.LEARNER;

    if (noDemo) {
      // запрещаем доступ для демо юзеров
      if (
        // не будем просить сервер, посчитаем сами, прошли ли демо дни для ученика
        isLearner &&
        (!purchases?.access ||
          moment(purchases?.access * 1000).diff(created, 'days') <= 7)
      ) {
        setAccessModalShow(true); // если нет, покажем модалку
        return;
      }

      if (!isLearner) {
        // иначе попросим сервер найти оплаченных юзеров без демо дней
        setAccessModalShow(!paid);
        return;
      }
    }

    // проверим текущий доступ или количество оплаченных учеников
    if (!(purchases?.access > Date.now() / 1000 || user.payingStudents > 0)) {
      setAccessModalShow(true);
    }
  }, [purchases, paid]);

  return accessModalShow ? (
    <Modal show close={handleClose}>
      <Flex flexDirection="column" alignItems="center">
        <Box mb={6} style={{ maxWidth: '500px', textAlign: 'center' }}>
          <FormattedMessage id="NO_ACCESS" defaultMessage="" />.{' '}
          {olimpicType &&
          !purchases[
            {
              [TYPE.ONLINE]: 'olimpic_1',
              [TYPE.OFFLINE]: 'olimpic_2',
              [TYPE.PAMA_OFFLINE]: 'olimpic_4',
            }[olimpicType]
          ] ? (
            <FormattedMessage id="ACCESS_NO_OLIMPIC" defaultMessage="" />
          ) : (
            <>
              <FormattedMessage
                id={
                  role === ROLE.LEARNER
                    ? 'ACCESS_NO_DEMO_FUNDS'
                    : 'ACCESS_ISUFFICIENT_FUNDS_TEACHER'
                }
                defaultMessage=""
              />
              .{' '}
            </>
          )}
        </Box>

        <Flex mt={9}>
          <Box mr={6}>
            <StyledButton component={Link} to="/ucoins">
              <FormattedMessage id="PURCHASES" defaultMessage="" />
            </StyledButton>
          </Box>
          <StyledButton onClick={handleClose}>
            <FormattedMessage id="CANCEL" defaultMessage="" />
          </StyledButton>
        </Flex>
      </Flex>
    </Modal>
  ) : (
    children
  );
};

PurchaseModal.propTypes = {
  user: PropTypes.object.isRequired,
  olimpic: PropTypes.object.isRequired,
  onLoad: PropTypes.func.isRequired,
  children: PropTypes.any,
  noDemo: PropTypes.bool,
  olimpicType: PropTypes.string,
  exclude: PropTypes.bool,
};

PurchaseModal.defaultProps = {
  children: <></>,
  noDemo: false,
  olimpicType: '',
  exclude: false,
};

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  onLoad() {
    dispatch(fetchTeacherPaid());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseModal);
